//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FixBottom from "@/components/FixedBottom";
import TabMenu from "@/components/TabMenu.vue";
import License from "@/components/License.vue";
import Header from "./components/Header.vue";
import Links from "./components/Links.vue";
import { CacheMixin } from "@/mixins/index";
export default {
  name: "my",
  components: {
    FixBottom,
    TabMenu,
    License,
    MyHeader: Header,
    Links,
  },
  mixins: [CacheMixin],
  data() {
    return {};
  },
  mounted() {
    this.STATISTICS("load", "insur_mall_my_page", "jr");
  },
};
